export default __webpack_public_path__ + "static/media/1.51376033.png";